import {
  Avatar,
  Box,
  CardContent,
  CardHeader,
  Typography,
} from '@mui/material';

import { DisplayCard } from '@schamburg-web/lakecounty';
import React from 'react';
import { messageSignIcon } from '.';
import { ModuleCardProps } from '../types';
import { getLocationDescription, getNormalizedIcon } from '../utils';
import CardCloseButton from '../../components/CardCloseButton/CardCloseButton';

const MessageSignCard: React.FC<ModuleCardProps> = ({ icon, module }) => {
  const normalizedIcon = getNormalizedIcon(icon);
  const { msg } = normalizedIcon || {};

  return (
    <Box sx={{ maxWidth: 500, width: '100%', position: 'relative' }}>
      <DisplayCard icon={icon} module={module}>
        <CardHeader
          action={<CardCloseButton />}
          avatar={
            <Avatar
              src={messageSignIcon}
              sx={{ width: 40, height: 40 }}
              alt="Message Sign Icon"
            />
          }
          title={
            <Typography variant="subtitle1">
              {getLocationDescription(normalizedIcon) || 'No location provided'}
            </Typography>
          }
          sx={{ paddingBottom: 1 }}
        />

        <CardContent sx={{ pt: 0, pb: 0, '&:last-child': { pb: 1 } }}>
          <Box
            className="message-sign-content"
            dangerouslySetInnerHTML={{ __html: msg }}
          />
        </CardContent>
      </DisplayCard>
    </Box>
  );
};

export default MessageSignCard;
